import { render, staticRenderFns } from "./modifyPwd.vue?vue&type=template&id=c683f912&scoped=true"
import script from "./modifyPwd.vue?vue&type=script&lang=js"
export * from "./modifyPwd.vue?vue&type=script&lang=js"
import style0 from "./modifyPwd.vue?vue&type=style&index=0&id=c683f912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c683f912",
  null
  
)

export default component.exports